const openFeaturesModal = (e) => {
  e.preventDefault();
  const featuresModal = document.querySelector('#features-modal');
  featuresModal.classList.add('active');
  document.body.classList.add('body--scroll-locked');
};

const closeFeaturesModal = () => {
  const featuresModal = document.querySelector('#features-modal');
  featuresModal.classList.remove('active');
  document.body.classList.remove('body--scroll-locked');
};

export const handleFeaturesModal = () => {
  const featuresModal = document.querySelector('#features-modal');
  if (!featuresModal) return;

  const openFeaturesModalButton = document.querySelector(
    '.open-features-modal'
  );
  const closeFeaturesModalButton = document.querySelector(
    '#close-features-modal'
  );

  closeFeaturesModalButton.addEventListener('click', closeFeaturesModal);

  featuresModal.addEventListener('click', (event) => {
    if (event.target === featuresModal) {
      closeFeaturesModal();
    }
  });

  openFeaturesModalButton.addEventListener('click', openFeaturesModal);
};



// WEBPACK FOOTER //
// ./src/templates/components/property-perks/property-perks.js